import dayjs from 'dayjs';

import type { OpenMetadataHit } from '@/shared/api/openmetadata';

import type { SearchResult } from '@/entities/search/domain/types';

import { filterAndMapTags } from './tagUtils';

export const transformOpenMetadataToSearchResult = (hit: OpenMetadataHit): SearchResult => {
  const source = hit._source;

  return {
    id: source.id,
    title: source.displayName || source.name,
    description: source.description || '',
    type: source.entityType as SearchResult['type'],
    updatedAt: dayjs(source.updatedAt).toISOString(),
    owner: {
      name: source.owners?.[0]?.displayName || 'Unknown',
      department: undefined,
      email: undefined,
    },
    path: source.fullyQualifiedName || source.name,
    tags: filterAndMapTags(source.tags),
    tier: source.tier
      ? {
          tagFQN: source.tier.tagFQN,
          name: source.tier.name,
          description: source.tier.description,
        }
      : undefined,
    serviceType: source.serviceType,
    database: source.database
      ? {
          id: source.database.id,
          type: source.database.type,
          name: source.database.name,
          displayName: source.database.displayName,
        }
      : undefined,
    databaseSchema: source.databaseSchema
      ? {
          id: source.databaseSchema.id,
          type: source.databaseSchema.type,
          name: source.databaseSchema.name,
          displayName: source.databaseSchema.displayName,
        }
      : undefined,
    service: source.service
      ? {
          id: source.service.id,
          type: source.service.type,
          name: source.service.name,
          displayName: source.service.displayName,
          description: source.service.description,
        }
      : undefined,
  };
};
